import { ROLES } from "@/constants/roles"
import { RouteConfig } from "vue-router"

export const pricingPlansRoutes: RouteConfig[] = [
    {
        path: "pricing-plans",
        component: () => import("@/layouts/Wrapper.vue"),
        meta: {
            title: "Pricing Plans",
            maintainsContext: true,
            requiresAuth: true,
            permissions: [ROLES.ADMIN],
        },
        children: [
            {
                path: "",
                component: () => import("@/views/pricing-plans/PricingPlans.vue"),
                name: "PricingPlansView",
                meta: {
                    title: "Pricing plans",
                    maintainsContext: true,
                },
            },
            {
                path: "configs",
                component: () => import("@/layouts/Wrapper.vue"),
                meta: {
                    title: "Predefined price lists",
                    maintainsContext: true,
                },
                children: [
                    {
                        path: "",
                        name: "PricingConfigs",
                        component: () => import("@/views/pricing-plans/PricingConfigsList.vue"),
                        meta: {
                            title: "Predefined price lists",
                            maintainsContext: true,
                        },
                    },
                    {
                        path: "create",
                        name: "CreatePricingConfig",
                        component: () => import("@/views/pricing-plans/PricingConfigEdit.vue"),
                        meta: {
                            title: "Create",
                            maintainsContext: true,
                        },
                    },
                    {
                        path: ":configId",
                        name: "EditPricingConfig",
                        component: () => import("@/views/pricing-plans/PricingConfigEdit.vue"),
                        meta: {
                            title: "Edit",
                            maintainsContext: true,
                        },
                    },
                ],
            },
        ],
    },
]
